import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Chip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { fetchAllAlarms } from "../../../api/AlarmApi";

const AlarmsView = () => {
  const navigate = useNavigate();

  const { data: alarmsResponse, isLoading } = useQuery(
    ["allAlarms"],
    fetchAllAlarms,
    { staleTime: 30_000 }
  );

  const userData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData") || "{}");
    } catch {
      return {};
    }
  }, []);

  const sorted = useMemo(() => {
    const list = alarmsResponse?.data;
    if (!Array.isArray(list)) return [];
    const filtered = userData.organisation_id
      ? list.filter((a) => String(a.organisation_id) === String(userData.organisation_id))
      : list;
    return [...filtered].sort((a, b) => new Date(b.started) - new Date(a.started));
  }, [alarmsResponse, userData.organisation_id]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        Larmhistorik
      </Typography>
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 1 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 700, bgcolor: "grey.50" } }}>
              <TableCell>Datum</TableCell>
              <TableCell>Typ</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Grupp</TableCell>
              <TableCell align="right">Detaljer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sorted.map((alarm) => (
              <TableRow key={alarm.id} hover>
                <TableCell>
                  {new Date(alarm.started).toLocaleString("sv-SE", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </TableCell>
                <TableCell>{alarm.alarm_type || "—"}</TableCell>
                <TableCell>
                  <Chip
                    label={alarm.is_active ? "Aktiv" : "Avslutad"}
                    color={alarm.is_active ? "error" : "default"}
                    size="small"
                  />
                </TableCell>
                <TableCell>{alarm.group_id || "—"}</TableCell>
                <TableCell align="right">
                  <IconButton
                    size="small"
                    onClick={() =>
                      navigate(`/admin/alarm/details/${alarm.id}`)
                    }
                  >
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {sorted.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{ py: 4, color: "text.secondary" }}
                >
                  Inga larm hittades
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AlarmsView;
